export const TravelFormConstants = {
  PRELIMINARY: "Preliminary",
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected"
};
